/**
 * Generato automaticamente.
 * framework-cfg-procedimenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { AnagraficaColoriDTO } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Restituisce gli anagrafica colori
 * @summary Restituisce gli anagrafica colori
 */
export const getAnagraficaColori = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<AnagraficaColoriDTO[]>(
    {
      url: `/framework-cfg-procedimenti/anagrafica-colori`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetAnagraficaColoriQueryKey = () =>
  [`/framework-cfg-procedimenti/anagrafica-colori`] as const;

export const getGetAnagraficaColoriQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnagraficaColori>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAnagraficaColori>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getAnagraficaColori>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAnagraficaColoriQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnagraficaColori>>
  > = ({ signal }) => getAnagraficaColori(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetAnagraficaColoriQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnagraficaColori>>
>;
export type GetAnagraficaColoriQueryError = ErrorType<unknown>;

/**
 * @summary Restituisce gli anagrafica colori
 */
export const useGetAnagraficaColori = <
  TData = Awaited<ReturnType<typeof getAnagraficaColori>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAnagraficaColori>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAnagraficaColoriQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
